var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "generic-notification-modal",
      style: {
        "--gap": _vm.gap,
      },
      attrs: {
        name: _vm.name,
        adaptive: true,
        "max-width": _vm.maxWidth,
        width: _vm.width,
        height: _vm.height,
        clickToClose: false,
      },
    },
    [
      _c(
        "section",
        { staticClass: "generic-notification" },
        [
          _vm.image
            ? _c("div", { staticClass: "generic-notification__image-block" }, [
                _c("img", { attrs: { src: _vm.image } }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.title
            ? _c("h3", { staticClass: "generic-notification__title" }, [
                _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.notificationBar
            ? _c(
                "notification-bar",
                _vm._b(
                  { staticClass: "generic-notification__alert" },
                  "notification-bar",
                  _vm.notificationBar,
                  false
                ),
                [
                  _vm.$slots.notification
                    ? _vm._t("notification")
                    : _vm.notificationBar.text
                    ? [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.notificationBar.text) +
                            "\n      "
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.subtitle || _vm.$slots.default
            ? _c("div", { staticClass: "generic-notification__description" }, [
                _vm.subtitle
                  ? _c(
                      "h4",
                      {
                        staticClass: "generic-notification__description-title",
                      },
                      [_vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.$slots.default
                  ? _c(
                      "p",
                      { staticClass: "generic-notification__description-text" },
                      [_vm._t("default")],
                      2
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "generic-notification__action" },
            [
              _c(
                "a",
                {
                  staticClass: "generic-notification__action-skip",
                  on: { click: _vm.handleClickSkip },
                },
                [_vm._v("\n        Skip for now\n      ")]
              ),
              _vm._v(" "),
              _vm.actionText
                ? _c(
                    "PrimaryButton",
                    {
                      staticClass: "generic-notification__action-button",
                      on: { click: _vm.handleClickAction },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.actionText) + "\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }